module.exports = __webpack_public_path__ + "static/media/franchise-02.6658cc0a.png";